const FIREBASE_CONFIG = {
    "projectId": "guidde-dev-staging",
    "appId": "1:824103114815:web:920ecf835920e36ead808a",
    "databaseURL": "https://guidde-dev-staging-default-rtdb.firebaseio.com",
    "storageBucket": "guidde-dev-staging.appspot.com",
    "locationId": "us-central",
    "apiKey": "AIzaSyAECvQGtSbTa6P0o69l-fGgrMp2xLAeKlY",
    "authDomain": "stg.guidde.com",
    "messagingSenderId": "824103114815",
    "measurementId": "G-HMRHP70X5B",
    "environment": "staging"
}
const EU_CONFIG = {
    "projectId": "guidde-production-eu",
    "appId": "1:479143857377:web:0c790f4493f23549487ba0",
    "databaseURL": "https://guidde-production-eu-default-rtdb.europe-west1.firebasedatabase.app",
    "storageBucket": "guidde-production-eu.appspot.com",
    "locationId": "europe-west",
    "apiKey": "AIzaSyC_n-2owO4Ic6C7BJW8PM5q-BsGZWysyhI",
    "authDomain": "eu.guidde.com",
    "messagingSenderId": "479143857377",
    "environment": "staging"
}

const Config = Object.freeze({
    firebase: FIREBASE_CONFIG,
    eu: EU_CONFIG,
    idKey: '',
})
export default Config

export const STIGG_CLIENT_KEY =
'$2b$10$2tLiBrjgm05excoNtNqQS.PvzVTP.dnsM3fL/Jk77AeedV6moEpIO:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const entailApiKey =
'et-WJgibNJi14XN2kj8esMTq2ke_JhVpI8n5kq0lPv1-2eEnbIv'
export const tapfiliateAccountId =
'47910-93439a'